import { getLocaleDateFormat } from "./getLocaleDateFormat"

const dayAbbreviation = "D"
const monthAbbreviation = "M"
const yearAbbreviation = "Y"

/*
 * this expects as an argument a string in the format returned
 * by getLocaleDateFormat
 *
 * it converts the string to a Date
 */
export function getDateFromLocaleDateString(language: string, dateString: string): Date {
  const { dateFormat } = getLocaleDateFormat({
    language,
    dayAbbreviation,
    monthAbbreviation,
    yearAbbreviation,
  })

  let day = ""
  let month = ""
  let year = ""

  dateFormat.split("").forEach(
    (char, index) => {
      if (char === dayAbbreviation) {
        day += dateString[index]
      } else if (char === monthAbbreviation) {
        month += dateString[index]
      } else if (char === yearAbbreviation) {
        year += dateString[index]
      }
    },
  )

  const date = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
  )

  /*
   * the user could pass values of 99 for month or day, and js would construct a
   * valid date by going 99 months and 99 days into the future from the given
   * year
   *
   * any dates constructed this way will be considered invalid
   */
  if (
    date.getFullYear() !== Number(year) ||
    date.getMonth() !== (Number(month) - 1) ||
    date.getDate() !== Number(day)
  ) {
    return new Date(NaN)
  }

  return date
}
